// extracted by mini-css-extract-plugin
export var parcelRow = "_u5-0";